<app-display-menu-section-body-container [nMenus]="nMenus" [index]="index">
  <div class="section-body-container">
    <app-display-menu-section-options
      [menu]="menu"
      [productOverflowTitle]="productOverflowTitle"
      [mergeKey]="mergeKey"
      [bindTo]="bindTo"
      [loopDuration]="loopDuration"
      [nMenus]="nMenus"
      [menuIsPartOfCollection]="menuIsPartOfCollection"
      (openInformationModal)="openInformationModal.emit($event)">
    </app-display-menu-section-options>
  </div>
</app-display-menu-section-body-container>
